import { PromotionService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as promotion from './types';

const actions = {
  async [promotion.FETCH_MAIN_PROMOTIONS]() {
    const { data } = await PromotionService.getMainPromotions();
    return data;
  },
};

export default actions;
